import { createSlice, isAnyOf } from '@reduxjs/toolkit'
import { getConfigSettingInfo } from '../async'

const initialState = {
  appSettingsLoader: false,
  appSettingsData: [],
  appSettingsError: '',
}

export const appSettingsSlice = createSlice({
  name: 'app-settings',
  initialState,
  extraReducers: (builder) => {
    builder.addMatcher(isAnyOf(getConfigSettingInfo.pending), (state) => {
      state.appSettingsLoader = true
    })
    builder.addMatcher(isAnyOf(getConfigSettingInfo.fulfilled), (state, action) => {
      state.appSettingsData = action.payload.data
      state.appSettingsLoader = false
    })
    builder.addMatcher(isAnyOf(getConfigSettingInfo.rejected), (state, action) => {
      state.appSettingsLoader = false
      state.appSettingsError = action.payload
    })
  },
})

export default appSettingsSlice.reducer
